import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faEnvelope,
  faGlobe,
  faPhone,
  faArrowRightLong
} from '@fortawesome/free-solid-svg-icons';
import {
  faGithub,
  faInstagram,
  faXTwitter
} from '@fortawesome/free-brands-svg-icons';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-hero">
          <div className="footer-cta">
            <div className="footer-cta-icon">
              <FontAwesomeIcon icon={faArrowRightLong} />
            </div>
            <div>
              <p className="footer-kicker">Let&apos;s build your digital future.</p>
              <h3>Together.</h3>
              <p className="footer-summary">
                Strategy, design, engineering, and optimisation under one team.
              </p>
            </div>
          </div>

          <div className="footer-contact">
            <a href="https://www.digitalfig.com" target="_blank" rel="noopener noreferrer">
              <FontAwesomeIcon icon={faGlobe} />
              <span>www.digitalfig.com</span>
            </a>
            <a href="mailto:hello@digitalfig.com">
              <FontAwesomeIcon icon={faEnvelope} />
              <span>hello@digitalfig.com</span>
            </a>
            <a href="tel:+447578513420">
              <FontAwesomeIcon icon={faPhone} />
              <span>+44 7578 513420</span>
            </a>
          </div>
        </div>

        <div className="footer-content">
          <div className="footer-logo">
            <h3>Digital Fig</h3>
            <p>Enterprise Web Solutions & AI Automation</p>
          </div>

          <div className="footer-links">
            <h4>Navigation</h4>
            <ul>
              <li><a href="/#about">Our Services</a></li>
              <li><a href="/#projects">Case Studies</a></li>
              <li><a href="/ai-automation">AI Automation</a></li>
              <li><a href="/pricing">Pricing</a></li>
              <li><a href="/faq">FAQ</a></li>
              <li><a href="/contact">Contact Us</a></li>
            </ul>
          </div>

          <div className="footer-policies">
            <h4>Legal</h4>
            <ul>
              <li><a href="/privacy-policy">Privacy Policy</a></li>
              <li><a href="/cookie-policy">Cookie Policy</a></li>
              <li><a href="/terms-conditions">Terms & Conditions</a></li>
              <li><a href="/accessibility">Accessibility Statement</a></li>
              <li><a href="/website-packages-terms">Website Packages Terms</a></li>
              <li><a href="/custom-work-terms">Custom Work Terms</a></li>
              <li><a href="/refund-policy">Refund & Cancellation</a></li>
              <li><a href="/data-processing">Data Processing Agreement</a></li>
              <li><a href="/csr-policy">CSR Policy</a></li>
              <li><a href="/sustainability-policy">Sustainability Policy</a></li>
            </ul>
          </div>

          <div className="footer-social">
            <h4>Connect With Us</h4>
            <div className="social-icons">
              <a href="https://github.com/digital-fig" target="_blank" rel="noopener noreferrer" aria-label="GitHub Profile">
                <FontAwesomeIcon icon={faGithub} />
              </a>
              <a href="https://x.com/digitalf1g" target="_blank" rel="noopener noreferrer" aria-label="X (formerly Twitter) Profile">
                <FontAwesomeIcon icon={faXTwitter} />
              </a>
              <a href="https://instagram.com/digitalf1g" target="_blank" rel="noopener noreferrer" aria-label="Instagram Profile">
                <FontAwesomeIcon icon={faInstagram} />
              </a>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {currentYear} Digital Fig. All Rights Reserved. Registered in England & Wales.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
